import { useCallback } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIsClientReady } from '@atlassian/jira-ssr-toolkit/src/hooks/use-is-client-ready.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIsJiraUserFirstActiveWithinXDays } from './useIsJiraUserFirstActiveWithinXDays.tsx';
import { useYbrIsNewUserCrossFlow } from './useYbrIsNewUserCrossFlow.tsx';

type UseYbrCrossFlowSuppressionParams = {
	crossFlowProduct?: 'jpd' | 'confluence';
};

export const useYbrCrossFlowSuppression = ({
	crossFlowProduct = 'jpd',
}: UseYbrCrossFlowSuppressionParams = {}): { shouldSuppress: () => boolean } => {
	const [userIsNewUser] = useYbrIsNewUserCrossFlow({ crossFlowProduct });
	const [userIsWithin30Days] = useIsJiraUserFirstActiveWithinXDays(30);

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const isClientReady = fg('jfp-magma-fx-ybr-hydration-error') ? useIsClientReady() : !__SERVER__;

	const shouldSuppress = useCallback(() => {
		if (!isClientReady || !userIsNewUser) {
			return false;
		}

		if (
			crossFlowProduct === 'jpd' &&
			expVal('jira_ybr_first_batch_cross_flow', 'isYBREnabled', false)
		) {
			return userIsWithin30Days;
		}

		if (
			crossFlowProduct === 'confluence' &&
			expVal('jira_ybr_first_batch_cross_flow_confluence', 'isYBREnabled', false)
		) {
			return userIsWithin30Days;
		}

		return false;
	}, [userIsNewUser, crossFlowProduct, isClientReady, userIsWithin30Days]);

	return {
		shouldSuppress,
	};
};
